import React, { Component } from 'react'

class GenericErrorMessage extends Component {
    getMessage() {
        let message = '';

        try {
            message = this.props.errors[this.props.field]
        } catch (e) {
            message = false
        }

        return message;
    }

    render() {
        if (!this.getMessage()) {
            return <span id={this.props.anchor} />;
        }

        return (
            <span id={this.props.anchor} className="generic-error-message">
                {this.getMessage()}
            </span>
        )
    }
}

export default GenericErrorMessage


// WEBPACK FOOTER //
// ./src/components/common/generic_error_message/GenericErrorMessage.jsx